/* Meera — hide theme-rendered card star ratings for products with 0 reviews.
 *
 * Why JS and not CSS/Liquid:
 *   Klaviyo defaults the Shopify `reviews.rating` metafield to 5.0 even when
 *   `reviews.rating_count` is 0, so the Avante card paints a filled 5-star row
 *   ("★★★★★ 0 review") that is identical in the DOM to a real 5.0 product.
 *   rating_count is rendered only as TEXT inside .rating-count (no attribute),
 *   so CSS can't target it. We read that text and hide the whole .card__reviews
 *   block when the leading integer is 0 (locale-agnostic: "0 review", "0 avis").
 *
 * Stan — 2026-05-21
 */
(function () {
  function hideZeroReviewRatings(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var blocks = scope.querySelectorAll('.card__reviews');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (block.dataset.meeraReviewsChecked === '1') continue;
      var countEl = block.querySelector('.rating-count');
      if (!countEl) continue;
      var match = countEl.textContent.trim().match(/\d+/);
      if (match && parseInt(match[0], 10) === 0) {
        block.style.display = 'none';
      }
      block.dataset.meeraReviewsChecked = '1';
    }
  }

  function run() { hideZeroReviewRatings(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run when cards are injected async (collection filtering, pagination,
  // quick view, infinite scroll).
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          hideZeroReviewRatings(document);
          break;
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
